export default {"src":"/_next/static/media/SAND.80e6b696.svg","height":18,"width":18};